module.exports = __webpack_public_path__ + "img/tool_3.a9e13c5b.png";